import { SEGUROS_ASEGURAME, SEGUROS_CATOLICA } from './constants.util';

export function segurosByProyect(seguros) {
  const whiteLabel = process.env.REACT_APP_WHITE_LABEL;

  const segurosMostrar = {
    ASEGURAME: SEGUROS_ASEGURAME,
    CATOLICA: SEGUROS_CATOLICA,
  };

  return seguros.filter(seguro => seguro.codigo in segurosMostrar[whiteLabel]);
}

export function segurosActivos(seguros) {
  return Array.isArray(seguros) ? seguros.filter(seguro => seguro.activo) : [];
}
